import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@ui/primitives/utils';
export const PillTag = (param)=>{
    let { label, type = 'info' } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn('min-w-max rounded-[6px] px-2 py-0.5 text-sm leading-[1.4]', 'border bg-secondary text-muted-foreground', {
            'border-green-300 bg-green-900 text-green-300': type === 'success',
            'border-red-300 bg-red-900 text-red-300': type === 'error'
        }),
        children: label
    });
};
